// extracted by mini-css-extract-plugin
module.exports = {"container":"Sba1FNxnWDG5LztAT9apK"};